const statusConst = {
  UNPAID: 1,
  PARTIAL: 2,
  PAID: 3,
  VENDOR: 1,
  APPROVAL_DRAFT: 111,
  REJECT: 112,
}

const statusColors = [
  { id: 1, name: 'Unpaid', color: '#CF2A28' },
  { id: 2, name: 'Partial', color: '#EB9234' },
  { id: 3, name: 'Paid', color: '#11A428' },
  { id: statusConst.APPROVAL_DRAFT, name: 'Approval Draft', color: '#13A4FF' },
  { id: statusConst.REJECT, name: 'Reject', color: '#CF2A28' },
]

export { statusConst, statusColors }
